import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AppFrame } from "./components/AppFrame";
import { PwaStatus } from "./components/PwaStatus";
import { GameProvider } from "./game/GameContext";
import { GameScreen } from "./screens/GameScreen";
import { HomeScreen } from "./screens/HomeScreen";
import { InstallScreen } from "./screens/InstallScreen";
import { ResultsScreen } from "./screens/ResultsScreen";
import { SettingsScreen } from "./screens/SettingsScreen";
import { ShopScreen } from "./screens/ShopScreen";

const basename = import.meta.env.BASE_URL.replace(/\/$/, "") || "/";

export function App(): React.JSX.Element {
  return (
    <GameProvider>
      <BrowserRouter basename={basename}>
        <Routes>
          <Route element={<AppFrame />}>
            <Route index element={<HomeScreen />} />
            <Route path="play" element={<GameScreen />} />
            <Route path="shop" element={<ShopScreen />} />
            <Route path="settings" element={<SettingsScreen />} />
            <Route path="install" element={<InstallScreen />} />
            <Route path="results/:runId" element={<ResultsScreen />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
        <PwaStatus />
      </BrowserRouter>
    </GameProvider>
  );
}
